// extracted by mini-css-extract-plugin
module.exports = {"referralsRewards":"referrals-rewards_referralsRewards__CQP0n","text":"referrals-rewards_text__2Dcc2"};